/**
 * Ресурси глобального пошуку: назва `SearchResource` бека → ключ фронт-ресурсу
 * картки (`SPEC-014` §5.3).
 *
 * Окрема мапа, а не `ResourceCorrespondenceConfig`: ключ прав і пошукова назва
 * не збігаються (контакти клієнта шукаються як `ClientContact`, а права
 * мають під `Client`), і рядок контактів у мапі прав перебив би її зворотний
 * бік — кнопка «Додати» на вкладці контактів зникла б мовчки.
 *
 * Порядок записів — порядок груп у видачі (як у легасі): «Перевізники»,
 * «Контакти перевізника», «Клієнти», «Контакти клієнта».
 *
 * Співробітники й відділи — `global: false` (Q14.4). Вартовий В-5
 * (`Ship/Helpers/architectureGuard.test.ts`) звіряє мапу з
 * `#[CA\SearchResource(global: true)]` беку.
 */
export const SEARCH_RESOURCES: Record<string, string> = {
    // Перевізник і його контакти (S5a–S5b, `SPEC-010` §5.4, §13)
    Carrier: 'Crm.Carrier',
    CarrierContact: 'Crm.CarrierContact',
    Client: 'Crm.Client',
    ClientContact: 'Crm.ClientContact',
    // Заявки (`SPEC-020` §9, `SPEC-021` §7, 021-Н4): ід, назва (= клієнт),
    // вантаж, адреси, водій, держ. номер ТЗ; права рядка — `ApplicationRule` (R-A).
    // Порядок груп — `SPEC-025` §3.4: після контактів клієнта, перед запитами
    Application: 'Transportation.Application',
    // Запити (`SPEC-020` §9, `SPEC-022` §7): назва, вантаж, опис текстом,
    // адреси; права рядка — `RequestRule` (R-R)
    Request: 'Transportation.Request',
    // Тендери (`SPEC-023` §4.1): те саме без адрес; права рядка — `TenderRule`
    Tender: 'Transportation.Tender',
    // Завдання — модуль з демки (`SPEC-018`): у демці шукалися глобально
    // (`#[CA\SearchResource(name: 'Task', global: true)]`), права рядка — TaskRule.
    // Після груп перевезень (`SPEC-025` §3.4.1, Q25.5)
    Task: 'Task',
}

/** Ключ фронт-ресурсу картки для назви ресурсу з видачі пошуку; `null` — немає. */
export const searchResourceKey = (backendResource: string): string | null => SEARCH_RESOURCES[backendResource] ?? null
